<!--@format-->
<template>
    <div class="success-animation-popup">
        <section class="animation-container">
            <success-animation />
        </section>
    </div>
</template>

<script>
const SuccessAnimation = () => import('@/assets/animations/success-animation');
export default {
    name: 'success-animation-popup',

    components: {
        'success-animation': SuccessAnimation,
    },
};
</script>

<style>
.success-animation-popup {
    display: flex;
    align-items: center;
    justify-content: center;
}

.success-animation-popup .animation-container {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
